import { render } from "./FactoryStats.vue?vue&type=template&id=7c4a8a49"
import script from "./FactoryStats.vue?vue&type=script&lang=js"
export * from "./FactoryStats.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__